import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ExpressionCompilerService, Ast} from '@ngmedax/expression-compiler';
import {Workflow} from '@ngmedax/common-questionnaire-types';
import {WorkflowVariableDescriptor, ValueType, DateKind} from './types';

@Component({
  selector: 'app-workflow-stage-conditions',
  templateUrl: './workflow-stage-conditions.component.html'
})
export class WorkflowStageConditionsComponent implements OnChanges, OnInit {
  @Input() workflow: Workflow;
  @Input() stageIndex: number;

  public variables: WorkflowVariableDescriptor[] = [];
  public group: Ast.Group = { type: 'group', operator: '&&', elements: [] } as any;

  public constructor(private compiler: ExpressionCompilerService) {}

  public ngOnInit() {
    const stage = (this.workflow && Array.isArray(this.workflow.stages)) ? this.workflow.stages[this.stageIndex] : null;
    stage && stage.expression && this.ngOnChanges({});
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.variables = this.buildVariableDescriptors(this.workflow);
    this.group = this.loadGroupFromWorkflow(this.workflow, this.stageIndex);
  }

  public onCompiledChange(expr: string) {
    if (!this.workflow || !Array.isArray(this.workflow.stages)) { return; }
    const stage = this.workflow.stages[this.stageIndex];
    if (!stage) { return; }
    (stage as any).expression = expr;
  }

  private loadGroupFromWorkflow(workflow: Workflow, idx: number): Ast.Group {
    try {
      const expr = workflow && (workflow.stages?.[idx] as any)?.expression;
      if (expr && typeof expr === 'string') {
        const g = this.compiler.parse(expr);
        // Default to AND when operator is missing (single-condition expressions)
        if (!(g as any).operator) {
          (g as any).operator = '&&';
        }
        return g;
      }
    } catch (e) {
      // fall back to empty group
    }
    return { type: 'group', operator: '&&', elements: [] } as any;
  }

  private buildVariableDescriptors(workflow: Workflow): WorkflowVariableDescriptor[] {
    const list: WorkflowVariableDescriptor[] = [];
    const vars: any[] = (workflow as any)?.variables || [];
    for (const v of vars) {
      const name: string = v?.name || '';
      const opts = v?.target?.options || {};
      const dataType: string | undefined = opts.dataType;
      const format: string | undefined = opts.format;
      let valueType: ValueType = 'string';
      let dateKind: DateKind | undefined;
      if (dataType === 'boolean' || format === 'boolean') {
        valueType = 'boolean';
      } else if (dataType === 'number' || format === 'numeric') {
        valueType = 'number';
      } else if (format === 'date') {
        valueType = 'date';
        if (opts.fullDate) { dateKind = 'fullDate'; }
        else if (opts.fullDateTime) { dateKind = 'fullDateTime'; }
        else if (opts.monthDate) { dateKind = 'monthDate'; }
        else if (opts.yearDate) { dateKind = 'yearDate'; }
      } else {
        valueType = 'string';
      }
      list.push({ name, valueType, dateKind });
    }
    return list;
  }
}


